export const userInputs = [
    {
      id: "id",
      label: "ID User",
      type: "text",
      placeholder: "Flynet",
    },
    {
      id: "name",
      label: "Name",
      type: "text",
      placeholder: "Flynet Garuda",
    },
    {
      id: "email",
      label: "Email",
      type: "mail",
      placeholder: "john_doe@gmail.com",
    },
    {
      id: "password",
      label: "Password",
      type: "password",
    },
    {
      id: "company_name",
      label: "Company Name",
      type: "text",
      placeholder: "PT Garuda ",
    },
  ];
  
  export const ticketOpenInputs = [
      {
          id: "number_ticket",
          label: "Nomor TT",
          type: "text",
          placeholder: "Nomor TT",
      },
  ];



export const ticketSolvedInputs = [
    {
        id: "summary",
        label: "Summary",
        type: "text",
        placeholder: "Summary",
    },
    {
        id: "action",
        label: "Action",
        type: "text",
        placeholder: "action ",
    },
    {
        id: "note",
        label: "Note",
        type: "text",
        placeholder: "Catatan tiket...",
    },
];


export const ticketUpdateLocalsite = [
    {
        id: "customer_site",
        label: "Customer Site",
        type: "text",
        placeholder: "Customer Site",
    },
    {
        id: "vendor_id",
        label: "Vendor Id",
        type: "text",
        placeholder: "Vendor ID",
    },
    {
        id: "root_cause",
        label: "Root Cause",
        type: "text",
        placeholder: "root cause",
    },
    {
        id: "action",
        label: "Action",
        type: "text",
        placeholder: "action ",
    },
    {
        id: "note",
        label: "Note",
        type: "text",
        placeholder: "Catatan tiket...",
    },
];


export const ticketClosedInputs = [
    {
        id: "classification",
        label: "Classification",
        type: "text",
        placeholder: "Splicing",
    },
    {
        id: "sla",
        label: "SLA",
        type: "text",
        placeholder: "1/2 ",
    },
    {
        id: "document_evidence",
        label: "Document Evidence",
        type: "text",
        placeholder: "foto link gambar/ ",
    },
];







export const ticketUpdateInputs = [
    {
        id: "number_ticket",
        label: "Nomor TT",
        type: "text",
        placeholder: "1232323",
    },
    {
        id: "segment_customer",
        label: "Segment Customer",
        type: "text",
        placeholder: "Nama Customer impact/down",
    },
    {
        id: "down_time",
        label: "Down Time",
        type: "text",
        placeholder: "Down Time",
    },

];

export const ticketCloseeInputs = [
    {
        id: "classification",
        label: "Classification",
        type: "text",
        placeholder: "Critical",
    },
    {
        id: "sla",
        label: "SLA",
        type: "text",
        placeholder: "1 atau 0",
    },
    {
        id: "document_evidence",
        label: "Document Evidence",
        type: "text",
        placeholder: "masih dalam proses build untuk fitur ini",
    },
   ]



